import * as actionTypes from "~/store/action_types";

const languages = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_LANGUAGES_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { languages } = entities;

      if (languages) {
        return languages;
      }
      return state;
    }
    case actionTypes.EDIT_SYSTEM_LANGUAGE_SUCCESS: {
      const previous = Object.values(state).find((language) => language.is_default);
      if (previous) {
        const { response = {} } = action;
        const { entities = {} } = response;
        const { languages } = entities;
        return {
          ...state,
          [previous.id]: {
            ...previous,
            is_default: false,
          },
          ...languages,
        };
      }
      return state;
    }
    default:
      return state;
  }
};

export default languages;
